import Mobile from "containers/mobile";

function Questionnaire({ onGoBack, onGoFwd }) {
  return <Mobile onGoBack={onGoBack} onGoFwd={onGoFwd} />;
}

export default Questionnaire;
